export default __webpack_public_path__ + "static/media/2.1.81cfe4b1.webm";